/* eslint-disable no-console */
import React from 'react';
import { Col, Label, Row } from 'reactstrap';
import Select from 'react-select';
import { useEffect } from 'react';
import { t } from 'i18next';
const DynamicDropDown = (props) => {
    const onSelectChanged = (e) => {
        props.changed(e);
    };
    const prepareSelectOptions = (list) => {
        let options = [];
        if (list?.length > 0) {
            list.forEach((li) => {
                options.push({ label: li.answerText, value: li.answerInternalIdentifier });
            });
        }
        return options;
    };
    const getPlaceholder = () => {
        let placeholder = props.placeholder || props.questionText || t('enterYourEmail');
        if (props.isMandate) return `${placeholder} *`;
        else {
            return `${placeholder}`;
        }
    };

    return (
        <React.Fragment>
            {/* {props.type === 120 ? ( */}
            <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="pe-0 mt-0" id={props?.answerInternalIdentifier}>
                <Select
                    // id={num}
                    id={props?.answerInternalIdentifier}
                    className="w-100 ht-fitcontent"
                    value={props.value || null}
                    onChange={onSelectChanged}
                    options={prepareSelectOptions(props.answers || props.options)}
                    components={{
                        IndicatorSeparator: () => null
                    }}
                    // id={props?.answerInternalIdentifier}
                    isDisabled={props.disable}
                    onBlur={props.handleOnBlur}
                    // placeholder={props.placeholder}
                    // placeholder={getPlaceholder()}
                />
            </Col>
            {/* ) : (
                <Select
                    className="w-100 ht-fitcontent"
                    value={props.value}
                    onChange={onSelectChanged}
                    options={prepareSelectOptions(props.answers || props.options)}
                    components={{
                        IndicatorSeparator: () => null
                    }}
                    id={props?.answerInternalIdentifier}
                    isDisabled={props.disable}
                    onBlur={props.handleOnBlur}
                    placeholder={props?.placeholder}
                /> */}
            {/* )} */}
        </React.Fragment>
    );
};

export default DynamicDropDown;
